import { Button, Stack } from 'components';
import { useFormikContext } from 'formik';
import { useHasUnsavedChanges } from 'utils/hooks/useHasUnsavedChanges';

import { FormValues } from '../clientForm';
import { CareTeam } from './careTeam';
import { EmergencyContact } from './emergencyContact';
import PersonalDetails from './personalDetails/personalDetails';
import { PrimaryAddress } from './primaryAddress';
import { Referral } from './referral';
import { SupportPeople } from './supportPeople';

const Profile = () => {
  const { handleSubmit, submitCount, dirty, isValid, submitForm } = useFormikContext<FormValues>();

  useHasUnsavedChanges(
    {
      isValid,
      submitForm
    },
    submitCount === 0 ? dirty : false
  );

  return (
    <form onSubmit={handleSubmit}>
      <Stack
        px="16px"
        py="28px"
        gap="32px"
        flex={8}
        sx={{
          overflow: 'scroll',
          maxHeight: '100vh'
        }}
      >
        <PersonalDetails />
        <PrimaryAddress context="primaryAddress" />
        <PrimaryAddress context="currentLocation" />
        <EmergencyContact />
        <SupportPeople />
        <CareTeam />
        <Referral />
        <Stack
          width="100%"
          display="flex"
          flexDirection="row"
          flex={2}
          justifyContent="end"
          data-test-id="profile-info-save"
        >
          <Stack width="100px">
            <Button disabled={!isValid} text="Save" theme="primary" />
          </Stack>
        </Stack>
      </Stack>
    </form>
  );
};

export default Profile;
